<template>
  <div class="client-container">
    <a-table
      :pagination="showPagination"
      :columns="tableColumns"
      :dataSource="tableDataList"
      :rowSelection="rowSelection"
      :scroll="{ x: 600, y: 450 }"
    >
    </a-table>

    <a-button
      @click.stop="closeWin"
      type="dashed"
      :style="{
        width: '200px',
        height: '40px',
        margin: '15px 10px 0px'
      }"
    >
      取 消
    </a-button>
    <a-button
      @click.stop="bindAuthGroup"
      type="primary"
      :style="{
        width: '200px',
        height: '40px',
        margin: '15px 10px 0px'
      }"
    >
      绑 定
    </a-button>
  </div>
</template>
<script>
var num = 0;
var pageContext;
export default {
  name: "AuthGroupBind",
  props: {
    itemData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    layerid: {
      type: String,
      default: ""
    },
    lydata: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      showPagination: false,
      tableColumns: [
        {
          title: "编号",
          dataIndex: "id",
          key: "id",
          width: "80px"
        },
        {
          title: "角色名称",
          dataIndex: "title",
          key: "title"
        }
      ],
      tableDataList: [],
      selectRowKeyList: [],
      rowSelection: {
        fixed: true,
        onChange: (selectedRowKeys, selectedRows) => {
          pageContext.selectRowKeyList = selectedRowKeys;
        },
        getCheckboxProps: record => {
          return {
            props: {
              defaultChecked: pageContext.selectRowKeyList.includes(record.id)
            }
          };
        }
      }
    };
  },
  mounted() {
    pageContext = this;
    pageContext.selectRowKeyList = pageContext.itemData.auth_groups;
    pageContext.refreshDataList();
  },
  methods: {
    async refreshDataList() {
      pageContext.$http
        .post("/AuthGroup/getDataList", {
          platform_type: pageContext.itemData.platform_type
        })
        .then(function(response) {
          if (response.data.status === 1) {
            pageContext.tableDataList = response.data.data.data_list;
          }
        })
        .catch(function(error) {
          pageContext.$message.error("请求异常，请检查");
          console.log(error);
        });
    },
    async bindAuthGroup() {
      pageContext.$http
        .post("/ManagerMg/bindAuthGroup", {
          id: pageContext.itemData.id,
          auth_groups: pageContext.selectRowKeyList
        })
        .then(function(response) {
          if (response.data.status === 1) {
            pageContext.$parent.refreshDataList();
            pageContext.$message.success(response.data.msg);
            pageContext.$layer.close(pageContext.layerid);
          }
        })
        .catch(function(error) {
          pageContext.$message.error("请求异常，请检查");
          console.log(error);
        });
    },
    closeWin() {
      pageContext.$message.info("操作取消");
      pageContext.$layer.close(pageContext.layerid);
    }
  }
};
</script>
<style lang="scss" scoped>
.client-container {
  width: 100%;
  text-align: center;

  .ant-btn-circle {
    margin: 0px 5px;
  }
}
</style>
